
import React, {useEffect, useState} from 'react'
import {DonateButton} from 'fepp'
import {ShareButtons, findApiV4Link} from 'shared'

export const Sticky = (props) => {
  const [visible, setVisible] = useState(false)
  const [left, setLeft] = useState(0)

  const handleScroll = (event) => {
    const triggerDistance = document.querySelector('.fundraising-events-show-numbers').getBoundingClientRect().top
    const untriggerDistance = (
      document.querySelector('.fundraising-events-show-sharing') || document.querySelector('footer')
    ).getBoundingClientRect().top
    setVisible(triggerDistance <= 0 && untriggerDistance >= 0)
  }

  const handleResize = (event) => {
    let bodyLeft = document.querySelector('body').getBoundingClientRect().left
    if (bodyLeft < 0) bodyLeft = 0
    setLeft(bodyLeft)
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    window.addEventListener('resize', handleResize)
    handleResize()
  }, [])

  if (props.fundraisingEvent.donations_prohibited) return null

  const shareUrl = findApiV4Link({ ofObject: props.fundraisingEvent, withRel: 'platform' })

  return <div id="sticky-bar" style={{opacity: visible ? 1 : 0, left: left}}>
    <div className="sticky-wrapper justify-between align-items-center d-flex">
      <div className="d-none d-md-block" >
        <strong dangerouslySetInnerHTML={{__html: props.fundraisingEvent.title}} />
      </div>
      <div className="d-flex fepp-actions">
        <div className="d-flex">
          <div className="d-flex align-items-center">
            <ShareButtons
              fundraisingEvent
              platforms={['facebook', 'whatsapp', 'link']}
              mobileOnly={['whatsapp']}
              shape='square'
              shareUrl={shareUrl}
              additionalClass='without-labels m-t-0 m-b-0 m-r-0 m-l-0'
              gaLabel='fepp_sticky'/>
          </div>
        </div>
        <div>
          <DonateButton fundraisingEvent={props.fundraisingEvent} gaAction='click donate_button__sticky' className='btn-large'/>
        </div>
      </div>
    </div>
  </div>
}
